import { arrToObj } from "fp-helpers-nba";
import Standings from "./../data/Standings.json";

export const standings = Standings;
export const standingsByID = arrToObj(Standings, "teamId", true);
